<button
  type="button"
  class="btn-impressao"
  (click)="onClick()"
  [disabled]="disabled"
>
<p>Exportar Excel</p>

  <img *ngIf="icon" [src]="icon" alt="Ícone de Excel" />
</button>
